import {el, mount} from 'redom';
import {FuncionalMask} from './masks';

export class PbmFuncionalFormBuilder {

  constructor(pbmFuncionalContainer, data) {
    this.data = data;
    this.pbmFuncionalContainer = pbmFuncionalContainer;
    this.pbmfuncionalForm = el('form', {id: 'pbm-form-funcional', novalidate: '', action: '#'});
    this.validation = {};

    this.init();
  }

  init() {
    if ((this.data) && this.data.atributos) {
      this.buildHeader();
      this.buildCamposBeneficiario();
      this.buildCamposPaciente();
      this.buildCamposProduto();
      this.buildCamposExtras();
      this.buildButtons();

      mount(this.pbmFuncionalContainer, this.pbmfuncionalForm);

      this.mask = new FuncionalMask();
    }
  }

  buildHeader() {
    mount(this.pbmFuncionalContainer,
      el('div',
        el('span',
          {
            class: 'pbm-titulo'
          },
          'Programa de Benefícios de Medicamentos'
        )
      ),      
      mount(this.pbmFuncionalContainer,
        el('div',
          el('span',
            {
              class: 'modal-text pbm-descricao'
            },
            'Economize com o programa do laboratório, informe seus dados e aproveite.'
          )
        )
      )
    );
  }

  buildButtons() {
    this.pbmfuncionalForm.appendChild(
      el('.form-control actions',
        el('button',
          {
            type: 'submit',
            class: 'btn btn--pbm btn--color-blue btn--icon btn--icon--right btn--text-bold'
          },
          el('i',
            {
              class: 'material-icons'
            },
            'keyboard_arrow_right'
          ),
          'cadastrar'
        ),
        el('button',
          {
            type: 'button',
            class: 'btn btn--no-bg btn--icon btn--icon--left',
            'data-modal': 'close'
          },
          el('i',
            {
              class: 'material-icons'
            },
            'keyboard_arrow_left'
          ),
          'Cancelar'
        )
      )
    );
  }

  buildCamposBeneficiario() {
    if(this.data.atributos.camposBeneficiario != null && this.data.atributos.camposBeneficiario.length > 0) {
      this.pbmfuncionalForm.appendChild(el('span', {class: 'form-title', 'data-title': 'beneficiario'}, 'Sobre Você'));
      Array.prototype.forEach.call(this.data.atributos.camposBeneficiario, attr => {
        this.buildTag(attr);
      });
    }
  }

  buildCamposPaciente() {
    if(this.data.atributos.camposPaciente != null && (this.data.atributos.camposPaciente.length > 0)) {
      const utilizaPacientes = this.data.atributos.utilizaPacientes;

      this.pbmfuncionalForm.appendChild(el('span', {class: 'form-title', 'data-title': 'paciente'}, 'Sobre o Paciente'));
      Array.prototype.forEach.call(this.data.atributos.camposPaciente, attr => {
        this.buildTag(attr, utilizaPacientes);
      });
    }
  }

  buildCamposProduto() {
    if(this.data.atributos.camposProduto != null && this.data.atributos.camposProduto.length > 0) {
      this.pbmfuncionalForm.appendChild(el('span', {class: 'form-title', 'data-title': 'medico'}, 'Sobre o Médico'));
      Array.prototype.forEach.call(this.data.atributos.camposProduto, attr => {
        this.buildTag(attr);
      });
    }
  }

  buildCamposExtras() {
    if(this.data.atributos.camposExtras != null && this.data.atributos.camposExtras.length > 0) {
      this.pbmfuncionalForm.appendChild(el('span', {class: 'form-title', 'data-title': 'extras'}, 'Informações adicionais'));
      Array.prototype.forEach.call(this.data.atributos.camposExtras, attr => {
        this.buildTag(attr);
      });
    }
  }

  buildConstraint(attr) {
    if (attr.exibicao.toUpperCase() == 'OBRIGATORIO') {
      if(attr.campo.toUpperCase() == 'EMAIL'){
        this.validation[attr.campo + "-" + attr.entidade.toLowerCase()] = {presence: {message: '^Preenchimento é obrigatório.'}, email: {message: "não é válido."}}
      }else {
        this.validation[attr.campo + "-" + attr.entidade.toLowerCase()] = {presence: {message: '^Preenchimento é obrigatório.'}}
      }
    } else {
      this.validation[attr.campo + "-" + attr.entidade.toLowerCase()] = {presence: {message: '^Preenchimento é obrigatório.'}}
    }
  }

  buildInputTag(attr,utlizaPaciente) {
    if(!this.inputsHides(attr, utlizaPaciente)) {
      this.buildConstraint(attr);

      let value = null

      if (attr.campo.toLowerCase() == 'nome' && this.data.atributos.pacientes != null) {
        value = this.data.atributos.pacientes[0].nome
      }

      if (attr.campo.toUpperCase() == 'CEP') {
        this.pbmfuncionalForm.appendChild(
          el('.form-control',
            el('input',
              {
                type: 'text',
                class: 'form-control__input',
                placeholder: attr.nomeExibicao,
                name: attr.campo + "-" + attr.entidade.toLowerCase(),
                'data-entidade': attr.entidade.toLowerCase(),
                id: 'input-' + attr.campo,
                value: value
              }
            ),
            el('a',
            {
              href: 'http://www.buscacep.correios.com.br/',
              class: 'link link--light-blue pbm-cep cep-pbm',
              target: '_blank'
            },
            'Não sei meu CEP')
          )
        );
      } else {
        this.pbmfuncionalForm.appendChild(
          el('.form-control',
            el('input',
              {
                type: 'text',
                class: 'form-control__input',
                placeholder: attr.nomeExibicao,
                name: attr.campo + "-" + attr.entidade.toLowerCase(),
                'data-entidade': attr.entidade.toLowerCase(),
                id: 'input-' + attr.campo
              }
            )
          )
        );
      }
    }
  }

  buildDateTag(attr, utlizaPaciente) {
    if(!this.inputsHides(attr, utlizaPaciente)) {
      this.buildConstraint(attr);

      let value = null

      if (this.data.atributos.pacientes != null) {
        let dataCompleta = this.data.atributos.pacientes[0].dataNascimento
        let dataNascimento = dataCompleta.split('T')
        let data = dataNascimento[0].split('-')
        value = `${data[2]}/${data[1]}/${data[0]}`
      }      

      this.pbmfuncionalForm.appendChild(
        el('div',
          {
            class: 'form-control'
          },
          el('input',
            {
              class: 'form-control__input',
              id: 'input-' + attr.campo,
              placeholder: attr.nomeExibicao,
              'data-input': '',
              'data-entidade': attr.entidade.toLowerCase(),
              name: attr.campo + "-" + attr.entidade.toLowerCase(),
              value: value
            }
          )
        )
      );
    }
  }

  buildSelectTag(attr, utlizaPaciente) {
    if(!this.inputsHides(attr, utlizaPaciente)) {
      this.buildConstraint(attr);

      let value = null
      if (attr.campo.toLowerCase() == 'sexo' && this.data.atributos.pacientes != null) {
        if (this.data.atributos.pacientes[0].sexo == 'M') {
          value = 'M'
        } else {
          value = 'F'
        }
      }

      let select = el('select',
        {
          class: 'form-control__select',
          name: attr.campo + "-" + attr.entidade.toLowerCase(),
          'data-entidade': attr.entidade.toLowerCase(),
          id: 'select-' + attr.campo
        }, el('option',
          {
            value: ''
          },
          attr.nomeExibicao));

      Array.prototype.forEach.call(attr.opcoes, opt => {
        select.appendChild(
          el('option',
            {
              value: opt.valor
            },
            opt.texto
          )
        );
        return
      });

      if (value == null) {
        select.value = ''
      } else {
        select.value = value
      }

      this.pbmfuncionalForm.appendChild(
        el('div',
          {
            class: 'form-control select-icon'
          },
          select
        )
      );
    }
  }

  buildCheckboxTag(attr, utlizaPaciente) {
    if(!this.inputsHides(attr, utlizaPaciente)) {
      this.buildConstraint(attr);

      let titular = ''
      if (this.data.atributos.pacientes != null && this.data.atributos.pacientes[0].titular) {
        titular = 'checked'
      }      

      this.pbmfuncionalForm.appendChild(
        el('.form-control',
          el('label',
            {
              id: 'chk-' + attr.campo,
              class: 'form-control__check'
            },
            el('input',
              {
                type: 'checkbox',
                name: attr.campo + "-" + attr.entidade.toLowerCase(),
                'data-entidade': attr.entidade.toLowerCase(),
                id: 'chk-' + attr.campo,
                checked: titular
              }
            ),
            el('span',
              {
                class: 'checkmark'
              }
            ),
            attr.nomeExibicao
          )
        )
      );
    }
  }

  getTypeTag(type) {
    if (type.toUpperCase() == 'STRING' || type.toUpperCase() == 'INTEGER') {
      return 'input'
    }
    if (type.toUpperCase() == 'SELECT') {
      return 'select'
    }
    if (type.toUpperCase() == 'BOOLEAN') {
      return 'checkbox'
    }
    if (type.toUpperCase() == 'DATETIME') {
      return 'datetime'
    }
  }

  buildTag(attr, utlizaPaciente) {
    let type = this.getTypeTag(attr.tipo);
    if (type == 'input') {
      return this.buildInputTag(attr, utlizaPaciente);
    }

    if (type == 'datetime') {
      return this.buildDateTag(attr, utlizaPaciente);
    }

    if (type == 'select') {
      return this.buildSelectTag(attr, utlizaPaciente);
    }

    if (type == 'checkbox') {
      return this.buildCheckboxTag(attr, utlizaPaciente);
    }
  }

  inputsHides(attr, utlizaPaciente) {
    if(utlizaPaciente) {
      let inputs = ["NOME","NASCIMENTO","SEXO","TITULAR"];
      return inputs.includes(attr.campo.toUpperCase());
    }
    return false
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/components/modal/modal-pbm/pbm-funcional/pbm-funcional-form.builder.js